import { EventEmitter } from '@angular/core';
import * as deLocale from 'date-fns/locale/de';
import * as enLocale from 'date-fns/locale/en';
import { TranslateService } from '@ngx-translate/core';
var DateRangePickerComponent = (function () {
    function DateRangePickerComponent(translateService) {
        this.start = null;
        this.end = null;
        this.options = null;
        this.loadedStart = null;
        this.loadedEnd = null;
        this.onChange = new EventEmitter();
        this.options = {
            minYear: 2017,
            maxYear: 2118,
            displayFormat: 'DD.MM.YYYY',
            barTitleFormat: 'MMMM YYYY',
            dayNamesFormat: 'dd',
            firstCalendarDay: 1,
            locale: translateService.currentLang === 'de' ? deLocale : enLocale,
            minDate: new Date('2017-01-01'),
            maxDate: new Date('2118-12-31'),
            barTitleIfEmpty: '',
        };
    }
    DateRangePickerComponent.prototype.ngOnInit = function () {
        this.start = this.loadedStart ? this.castToDate(this.loadedStart) : new Date();
        this.end = this.loadedEnd ? this.castToDate(this.loadedEnd) : new Date();
    };
    DateRangePickerComponent.prototype.changeStart = function (value) {
        this.start = value;
        if (this.start > this.end) {
            this.end = this.start;
        }
        this.emitChanges();
    };
    DateRangePickerComponent.prototype.changeEnd = function (value) {
        this.end = value;
        if (this.start > this.end) {
            this.end = this.start;
        }
        this.emitChanges();
    };
    DateRangePickerComponent.prototype.emitChanges = function () {
        this.onChange.emit({
            beginDate: { day: this.start.getDate(), month: this.start.getMonth() + 1, year: this.start.getFullYear() },
            endDate: { day: this.end.getDate(), month: this.end.getMonth() + 1, year: this.end.getFullYear() },
        });
    };
    DateRangePickerComponent.prototype.castToDate = function (dateObject) {
        var year = dateObject.year;
        var month = dateObject.month;
        var day = dateObject.day;
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return new Date(year + "-" + month + "-" + day);
    };
    return DateRangePickerComponent;
}());
export { DateRangePickerComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/date-range-picker/date-range-picker.component.ts.pre-build-optimizer.js